import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AddUsersToGroupMutationVariables = Types.Exact<{
  data: Types.ModifyUsersInGroupInput;
}>;


export type AddUsersToGroupMutation = { addUsersToGroup?: { dynamicallyPresentUserIds: Array<string> } | null };


export const AddUsersToGroupDocument = /*#__PURE__*/ gql`
    mutation addUsersToGroup($data: ModifyUsersInGroupInput!) {
  addUsersToGroup(data: $data) {
    dynamicallyPresentUserIds
  }
}
    `;

export function useAddUsersToGroupMutation() {
  return Urql.useMutation<AddUsersToGroupMutation, AddUsersToGroupMutationVariables>(AddUsersToGroupDocument);
};